import { createAuthClient } from "better-auth/react";
import { organizationClient } from "better-auth/client/plugins";

const client = createAuthClient({
  baseURL: import.meta.env.VITE_API_URL || "https://news-assist-api.kardoe.workers.dev",
  basePath: "/auth/v1",
  plugins: [
    organizationClient(),
  ],
  fetchOptions: {
    credentials: 'include',
    onSuccess: (ctx) => {
      const authToken = ctx.response.headers.get("set-auth-token");
      if (authToken && typeof window !== 'undefined') {
        localStorage.setItem("bearer_token", authToken);
      }
    },
    auth: {
      type: "Bearer",
      token: () => {
        if (typeof window !== 'undefined') {
          return localStorage.getItem("bearer_token") || "";
        }
        return "";
      }
    }
  }
});

export default client;

// Export useful hooks
export const useSession = client.useSession;
export const useListOrganizations = client.useListOrganizations;
export const useActiveOrganization = client.useActiveOrganization;
